<template>
  <div class="list-events" :class="type">
    <template >
      <Event
        v-for="event in list"
        :key="event.id"
        :extreme="extreme"
        :large="large"
         :watch-video="(e) => $emit('watch-video', e)"
        :class="type"
        :event="event"
        v-on="$listeners"
      />
    </template>
  </div>
</template>

<script>
import Event from '@/components/events/Event'
import EventBreak from '@/components/events/EventBreak'
import OpenHours from '@/components/events/OpenHours'

export default {
  name: 'ListEvents',
  components: { OpenHours, EventBreak, Event },
  props: {
    list: Array,
    type: String,
    extreme: Boolean,
    large: Boolean,
  },
  methods: {
    getOpenHours(event) {
      return event.type.id === 5 ? event : false
    },
  },
}
</script>

<style lang="scss">
.list-events.vertical {
  @include PC {
    display: flex;
  }
}
</style>
